import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=8113437e&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=8113437e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8113437e",
  null
  
)

export default component.exports